import { useCallback } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import { loadAuthDraft } from "../../lib/authDraft"
import { resetLocationAuthState } from "../../lib/locationSwitch"
import { hrefForCurrentCinema } from "../../lib/cinemaSlugs"

export function useAuthModalClose() {
    const navigate = useNavigate()
    const location = useLocation()

    return useCallback(
        () => {
            resetLocationAuthState()

            const bg =
                (location.state as { backgroundLocation?: { pathname: string; search: string; hash: string } })
                    ?.backgroundLocation ?? loadAuthDraft()?.modalBackground

            if (bg) {
                navigate({ pathname: bg.pathname, search: bg.search, hash: bg.hash }, { replace: true })
                return
            }

            // Без фона не уходим «назад» в защищённый роут (уведомления и т.п.),
            // иначе снова сработает редирект на /auth и выхода не будет.
            navigate(hrefForCurrentCinema("/afisha"), { replace: true })
        },
        [navigate, location.state],
    )
}
